<template>

			<v-layout row wrap>
        <v-flex
					xs12
					sm6
					md3
          v-for="(item, i) in parts"
          :key="item.id"
				>

				<v-card>
					<img
						v-lazy="require(`@/assets/img/parts/part${item.id}.jpg`)"
						class="part-image"
					>

					<v-card-title primary-title class="justify-center">
							<h3 class="headline mb-0 text-xs-center">{{item.name}}</h3>
					</v-card-title>

					<v-card-actions class="justify-center">
							<v-btn slot="activator" flat color="red darken-4" @click="openDialog(i)">Подробнее</v-btn>
						</v-card-actions>
				</v-card>

        </v-flex>

						<v-dialog v-model="dialog" width="600px">
							<v-card>
								<v-card-title class="justify-center">
									<span class="headline">{{parts[currentPart].name}}</span>
								</v-card-title>

								<img
									:src="require(`@/assets/img/parts/part${parts[currentPart].id}.jpg`)"
									:alt="parts[currentPart].name"
								>

									<v-container v-if="parts[currentPart].details">
										<h6 class="title mb-2">Описание</h6>
										<v-divider></v-divider>

										<v-list>
											<v-list-tile>
												<v-list-tile-content class="font-weight-medium" >Машина</v-list-tile-content>
												<v-list-tile-content>{{ parts[currentPart].details }}</v-list-tile-content>
											</v-list-tile>
											<v-list-tile>
												<v-list-tile-content class="font-weight-medium">Бренд</v-list-tile-content>
												<v-list-tile-content>{{ parts[currentPart].brand }}</v-list-tile-content>
											</v-list-tile>
											<v-list-tile>
												<v-list-tile-content class="font-weight-medium">Страна производитель</v-list-tile-content>
												<v-list-tile-content>
													{{ parts[currentPart].country }}
													<template v-if="parts[currentPart].country === 'Германия' && isMobile()">🇩🇪</template>
													<template v-else-if="parts[currentPart].country === 'Германия / Япония' && isMobile()">🇩🇪 / 🇯🇵</template>
												</v-list-tile-content>
											</v-list-tile>

											<v-list-tile v-if="parts[currentPart].size">
												<v-list-tile-content class="font-weight-medium">Размер</v-list-tile-content>
												<v-list-tile-content>{{ parts[currentPart].size }}</v-list-tile-content>
											</v-list-tile>

										</v-list>
									</v-container>

							</v-card>
						</v-dialog>

      </v-layout>

</template>

<script>
import data from '@/assets/range.json'
import detectingMobile from '@/mixins/detectingMobile'

export default {
  mixins: [
		detectingMobile
	],
	data() {
    return {
			parts: data.parts,
			dialog: false,
			currentPart: 0
		}
	},
	methods: {
		openDialog(id) {
			this.currentPart = id
			this.dialog = true
		}
	}
}
</script>

<style lang="stylus">
.v-list__tile__content
	flex: 1 1 50%
	
.part-image
	width 100%
	height 265px
	object-fit contain
	object-position center center

</style>
